import { useState } from 'react';
import { TEAM_ROLE_LABELS } from 'modules/arena/onboarding/content';
import { TeamRole } from 'modules/arena/onboarding/types';
import { Input } from 'shared/components/ui/Input';
import { Button } from 'shared/components/ui/Button';
import { Badge } from 'shared/components/ui/Badge';
import { ArenaOnboardingState } from 'modules/arena/onboarding/useArenaOnboarding';

const ROLE_OPTIONS = Object.entries(TEAM_ROLE_LABELS) as [TeamRole, string][];

export function StepTeam(state: ArenaOnboardingState) {
  const [name, setName] = useState('');
  const [role, setRole] = useState<TeamRole>('instrutor');

  function handleAdd() {
    state.addTeamMember(name, role);
    setName('');
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-ink-secondary">
        Convide sua equipe: gestores, recepção e instrutores. Cada papel tem permissões diferentes.
      </p>

      <div className="flex items-end gap-3">
        <Input
          label="Nome"
          name="teamMemberName"
          value={name}
          onChange={(event) => setName(event.target.value)}
          className="flex-1"
        />
        <label className="flex flex-col gap-1 text-sm text-ink">
          Papel
          <select
            value={role}
            onChange={(event) => setRole(event.target.value as TeamRole)}
            className="rounded-lg border border-border px-3 py-2 text-sm"
          >
            {ROLE_OPTIONS.map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </label>
        <Button type="button" onClick={handleAdd}>
          Adicionar
        </Button>
      </div>

      {state.team.length > 0 && (
        <ul className="flex flex-col gap-2">
          {state.team.map((member) => (
            <li
              key={member.id}
              className="flex items-center justify-between rounded-xl border border-border/70 px-4 py-2"
            >
              <span className="text-sm font-medium text-ink">{member.name}</span>
              <div className="flex items-center gap-3">
                <Badge tone="accent">{TEAM_ROLE_LABELS[member.role]}</Badge>
                <button
                  type="button"
                  onClick={() => state.removeTeamMember(member.id)}
                  className="text-xs text-danger hover:underline"
                >
                  Remover
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
